<template>
  <el-card>
    <ht-action-panel :on-search="onSearch" :on-clear="onClear" />

    <ht-table ref="list" v-loading="isLoading" :data="list">
      <ht-table-column label="序号" type="index" fixed="left" />
      <ht-table-column
        v-for="item in title"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :min-width="item.width || 100"
        :fixed="item.fixed"
      >
        <template v-slot="{row}">
          <span v-if="item.label === '开始时间' || item.label === '结束时间'">{{ row[item.prop] ? parseTime(row[item.prop]) : '' }}</span>
          <span v-else-if="item.label === '状态'">{{ row.status.value }}</span>
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </ht-table-column>

      <ht-table-column-operation :width="80">
        <template v-slot="{row}">
          <ht-button type="text" icon="el-icon-view" @click="onView(row)">详情</ht-button>
        </template>
      </ht-table-column-operation>
    </ht-table>

    <ht-pagination
      style="float: right;margin-bottom: 10px"
      :total="page.total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.perPage"
      @pagination="getList"
    />
  </el-card>
</template>

<script>
import HtListContainer from '@/components/HtListContainer'
import { getTpmChecklists } from '@/api/test/tpm'
import { parseTime } from '@/utils'

export default {
  name: 'Index',
  extends: HtListContainer,
  data() {
    return {
      title: [
        { label: '路线名称', prop: 'routeName' },
        { label: '开始时间', prop: 'createdAt', width: 160 },
        { label: '结束时间', prop: 'finishTimestamp', width: 160 },
        { label: '状态', prop: 'staff' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    parseTime,
    getList() {
      this.isLoading = true
      getTpmChecklists(this.listQuery).then((resp) => {
        this.afterGetList(resp)
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    },
    onView(row) {
      console.log(row)
      this.$router.push({ name: 'tpmTaskDetail', params: { id: row.id }})
    }
  }
}
</script>

<style scoped>

</style>
